// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValidationReport_issues__dhVA8 {
  margin-top: 3rem;
}

.ValidationReport_formTextLabel__kRDiZ {
  margin: 0 1rem 0 1.5rem;
  text-align: justify;
  line-height: 1.2rem;
}

.ValidationReport_summaryStatusContainer__LLtzk {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 0.5rem;
}

.ValidationReport_summaryStatusLabel__lYsHT {
  width: 10%;
  margin-right: 3rem;
}

.ValidationReport_issuesToggle__ZSCp3 {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.5rem 1.5rem;
  padding: 0;
}

.ValidationReport_progressBarContainer__smqbr {
  width: 78%;
  margin-left: 1rem;
}

.ValidationReport_summarySegment__6moCI {
  cursor: pointer;
  transition: filter 0.15s ease, box-shadow 0.15s ease;
}

.ValidationReport_summarySegment__6moCI:hover,
.ValidationReport_summarySegment__6moCI:focus-visible {
  filter: brightness(0.9);
  outline: none;
}

.ValidationReport_summarySegmentActive__pZXOC {
  box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.9);
}

.ValidationReport_alert__bMcDU {
  width: 97%;
  margin: auto;
}

.ValidationReport_form__4B9t\\+ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  margin: 1rem 0 0;
}

.ValidationReport_formDetails__i9ziD {
  flex: 1 1;
  min-width: 0;
}

.ValidationReport_revalidateButton__RNlcR {
  align-self: center;
  flex: 0 0 auto;
  width: max-content !important;
  min-width: max-content;
  margin: 0 1.5rem 0 0;
  white-space: nowrap;
}

.ValidationReport_alertIcon__qhmbG {
  margin: 0 1rem 0 0;
}

.ValidationReport_alertTitle__vlEUr {
  margin-left: 1rem;
}

.ValidationReport_label__DA-9U {
  margin-right: 0.5rem;
}

.ValidationReport_successText__2YRAM {
  margin-top: 1rem;
}

.ValidationReport_jsonViewer__SCeVj {
  max-height: 38rem;
  overflow: auto;
  padding: 1rem;
  border: 1px solid var(--gray);
  border-radius: 0.25rem;
  background-color: #fff;
}

.ValidationReport_rawText__eOjGS {
  max-height: 38rem;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.ValidationReport_notificationContent__v6Udk {
  display: flex;
  justify-content: space-between;
}

.ValidationReport_labelsNotification__GVR8Z {
  margin-top: 1rem;
}

@media screen and (max-width: 1200px) {

  .ValidationReport_progressBarContainer__smqbr {
    width: 73%;
  }
}

@media screen and (max-width: 991px) {

  .ValidationReport_progressBarContainer__smqbr {
    width: 65%;
  }

  .ValidationReport_notificationContent__v6Udk {
    display: block;
  }

  .ValidationReport_form__4B9t\\+ {
    flex-direction: column;
    gap: 1rem;
  }

  .ValidationReport_revalidateButton__RNlcR {
    align-self: flex-start;
    margin-left: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/validationReport/ValidationReport.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oDAAoD;AACtD;;AAEA;;EAEE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":[".issues {\n  margin-top: 3rem;\n}\n\n.formTextLabel {\n  margin: 0 1rem 0 1.5rem;\n  text-align: justify;\n  line-height: 1.2rem;\n}\n\n.summaryStatusContainer {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 0.5rem;\n}\n\n.summaryStatusLabel {\n  width: 10%;\n  margin-right: 3rem;\n}\n\n.issuesToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.5rem 1.5rem;\n  padding: 0;\n}\n\n.progressBarContainer {\n  width: 78%;\n  margin-left: 1rem;\n}\n\n.summarySegment {\n  cursor: pointer;\n  transition: filter 0.15s ease, box-shadow 0.15s ease;\n}\n\n.summarySegment:hover,\n.summarySegment:focus-visible {\n  filter: brightness(0.9);\n  outline: none;\n}\n\n.summarySegmentActive {\n  box-shadow: inset 0 0 0 2px rgba(33, 37, 41, 0.9);\n}\n\n.alert {\n  width: 97%;\n  margin: auto;\n}\n\n.form {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2rem;\n  margin: 1rem 0 0;\n}\n\n.formDetails {\n  flex: 1;\n  min-width: 0;\n}\n\n.revalidateButton {\n  align-self: center;\n  flex: 0 0 auto;\n  width: max-content !important;\n  min-width: max-content;\n  margin: 0 1.5rem 0 0;\n  white-space: nowrap;\n}\n\n.alertIcon {\n  margin: 0 1rem 0 0;\n}\n\n.alertTitle {\n  margin-left: 1rem;\n}\n\n.label {\n  margin-right: 0.5rem;\n}\n\n.successText {\n  margin-top: 1rem;\n}\n\n.jsonViewer {\n  max-height: 38rem;\n  overflow: auto;\n  padding: 1rem;\n  border: 1px solid var(--gray);\n  border-radius: 0.25rem;\n  background-color: #fff;\n}\n\n.rawText {\n  max-height: 38rem;\n  margin: 0;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.notificationContent {\n  display: flex;\n  justify-content: space-between;\n}\n\n.labelsNotification {\n  margin-top: 1rem;\n}\n\n@media screen and (max-width: 1200px) {\n\n  .progressBarContainer {\n    width: 73%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n\n  .progressBarContainer {\n    width: 65%;\n  }\n\n  .notificationContent {\n    display: block;\n  }\n\n  .form {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .revalidateButton {\n    align-self: flex-start;\n    margin-left: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"issues": `ValidationReport_issues__dhVA8`,
	"formTextLabel": `ValidationReport_formTextLabel__kRDiZ`,
	"summaryStatusContainer": `ValidationReport_summaryStatusContainer__LLtzk`,
	"summaryStatusLabel": `ValidationReport_summaryStatusLabel__lYsHT`,
	"issuesToggle": `ValidationReport_issuesToggle__ZSCp3`,
	"progressBarContainer": `ValidationReport_progressBarContainer__smqbr`,
	"summarySegment": `ValidationReport_summarySegment__6moCI`,
	"summarySegmentActive": `ValidationReport_summarySegmentActive__pZXOC`,
	"alert": `ValidationReport_alert__bMcDU`,
	"form": `ValidationReport_form__4B9t+`,
	"formDetails": `ValidationReport_formDetails__i9ziD`,
	"revalidateButton": `ValidationReport_revalidateButton__RNlcR`,
	"alertIcon": `ValidationReport_alertIcon__qhmbG`,
	"alertTitle": `ValidationReport_alertTitle__vlEUr`,
	"label": `ValidationReport_label__DA-9U`,
	"successText": `ValidationReport_successText__2YRAM`,
	"jsonViewer": `ValidationReport_jsonViewer__SCeVj`,
	"rawText": `ValidationReport_rawText__eOjGS`,
	"notificationContent": `ValidationReport_notificationContent__v6Udk`,
	"labelsNotification": `ValidationReport_labelsNotification__GVR8Z`
};
export default ___CSS_LOADER_EXPORT___;
